export const ISSUE_STATUS = {
  PENDING: 10,
  RETURN_INITIATED: 20,
  RESOLVED: 30,
  REJECTED: 40,
  REFUND_ISSUED:50,
};

export function getFormattedTimestamp() {
  const now = new Date();
  const pad = (num) => num.toString().padStart(2, '0');

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1);
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatToDateOnly(inputDate) {
  if (!inputDate) return null;
  const date = new Date(inputDate);
  if (isNaN(date)) return null;

  const pad = (n) => n.toString().padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  return `${year}-${month}-${day}`;
}

export const WHATSAPP_VERIFICATION_TYPE = {
  MARK_READY: 20,
  MARK_READY_ORGANIC: 30,
  CUSTOMER_RETURN: 40
}